import { Toast, ToastComponentProps } from '#components/Toast'

export const IdenticalSnapshotsToast = (
  props: Partial<ToastComponentProps>,
) => (
  <Toast
    dismissable={false}
    message="Both snapshots are identical."
    {...props}
  />
)
